import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
// Automatically set the locale based on the user's browser settings.
let defaultLang
if (localStorage.getItem('language')) {
  defaultLang = localStorage.getItem('language')
} else {
  const userLang = navigator.language || navigator.userLanguage
  defaultLang = userLang.includes('en') ? 'en' : 'fr'
}

export default new VueI18n({
  locale: defaultLang,
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
})
